import { mapValues } from 'lodash';
import queryString, { stringify } from 'query-string';
import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Provides a getter/setter interface similar for query parameters.
 * Similar to useState in usage.
 *
 * @example
 * const [searchParams, setSearchParams] = useSearchParams();
 */
const useSearchParams = <T extends Record<string, string>>() => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = queryString.parse(location.search) as T;

  const setSearchParams = useCallback(
    (params: T) => {
      // eslint-disable-next-line no-console
      console.log('use callback');
      navigate({
        pathname: location.pathname,
        search: stringify(
          mapValues(
            params,
            // ensure that only truthy values end up in the query string
            (value) => value || undefined,
          ),
        ),
      });
    },
    [navigate, location],
  );

  return [searchParams as T, setSearchParams] as const;
};

export default useSearchParams;
